import { __extends } from "tslib";
import ImageItem from '../imageItem';
var VideoItemPlaceholder = /** @class */ (function (_super) {
    __extends(VideoItemPlaceholder, _super);
    function VideoItemPlaceholder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoItemPlaceholder.prototype.render = function () {
        var videoControls = this.props.videoControls;
        var VideoPlaceholderContainerClassnames = this.getImageContainerClassNames() + ' video-item gallery-item-video';
        var videoPlaceholderImageRenderer = this.getImageElement();
        var renderedItem = this.getImageContainer(videoPlaceholderImageRenderer, VideoPlaceholderContainerClassnames, videoControls);
        return renderedItem;
    };
    return VideoItemPlaceholder;
}(ImageItem));
export default VideoItemPlaceholder;
//# sourceMappingURL=videoItemPlaceholder.js.map